import dayjs from 'dayjs';

export const payloadBuilder = (payload) => {
  payload.startDate = dayjs(payload.startDate).format('YYYY-MM-DD');
  payload.endDate = dayjs(payload.endDate).format('YYYY-MM-DD');
  const result = payload;
  if(payload.type === '1'){
    delete result['imageContent'];
    delete result['contentImage'];
    delete result['image'];
  }else if(payload.type === '2'){
    delete result['description'];
    delete result['banner'];
    delete result['imageContent'];
    delete result['contentImage'];
  }else{
    delete result['contentImage'];
    delete result['description'];
    delete result['content'];

  }
  delete result['type'];
  delete result['status'];

  return result;
};


export const payloadEditBuilder = (payload) => {
  payload.startDate = dayjs(payload.startDate).format('YYYY-MM-DD');
  payload.endDate = dayjs(payload.endDate).format('YYYY-MM-DD');
  const result = payload;
  if(payload.type === '1'){
    if(payload.banner.length === 0){
      delete result['banner'];
    }
    delete result['imageContent'];
    delete result['contentImage'];
    delete result['image'];
  }else if(payload.type === '2'){
    delete result['description'];
    delete result['banner'];
    delete result['imageContent'];
    delete result['contentImage'];
  }else{
    delete result['contentImage'];
    delete result['description'];
    delete result['content'];
    if(payload.imageContent.length === 0){
      delete result['imageContent'];
    }
    if(payload.banner.length === 0){
      delete result['banner'];
    }
  }

  delete result['type'];
  delete result['status'];

  return result;
};

